export const PARAMETERS = {
    REDUX_LOGGER: false,
    REDUX_DEVTOOLS: false,
    REDUX_MONITOR: false,
    PANEL_URL: 'https://app.easysend.pl',
    API_DEV: '',
    API_RELEASE: '',
    APP_ID: {
        FACEBOOK: '', // This value will overwrite the value from the Wordpress Admin Panel,
        GOOGLE: '', // This value will overwrite the value from the Wordpress Admin Panel,
        APPLE: '', // This value will overwrite the value from the Wordpress Admin Panel,
    },
    TAWK: {
        IS_ENABLED: true,
        POLISH_CHANNEL: '5566f7ac7e314cc255082abc',
        ENGLISH_CHANNEL: '556700777e314cc255082cb3',
        RUSSIAN_CHANNEL: '5ab8e937d7591465c708ea9a',
        UKRAINIAN_CHANNEL: '5ab8ec924b401e45400e0f20'
    },
    DEFAULT_COOKIE_DOMAIN: '',
};
